import React, { useEffect, useState } from "react";
import { fetchUsers } from "../../../redux/api/admin.api";
import { getMonthActivityWmsReports } from "../../../redux/api/reports.api";
import { clearMonthlyActivityWmsReports } from "../../../redux/reducer/reports.reducer";

import { useAppDispatch, useAppSelector } from "../../../redux/hooks";

import TableWidget from "../../../components/tables/TableWidget";
import { TableActions } from "../../../components/tables/tableContext/TableContext";

import {
  getMonthlyActivityTableData,
  monthlyActivityTableHeader,
} from "./tableConfigs/monthlyActivityTableConfig";

import DropdownsPageHeader from "./components/DropdownsPageHeader";
import {
  filterTableDataByHeader,
  getFilteredTableHeader,
} from "../../../components/tables/tableHelper";

const PERMANENT_KEYS = ["userName", "prenume", "nume", "dataIntrarii"];

function MonthlyActivity() {
  const dispatch = useAppDispatch();

  const {
    reports: {
      monthActivityWmsReports: {
        data: { data: usersActivity, total },
        isLoading,
      },
    },
  } = useAppSelector((state) => ({
    reports: state.reports,
  }));

  const [currentTableSearch, setCurrentTableSearch] = useState<
    TableActions["tableSearch"]
  >({});

  useEffect(() => {
    dispatch(
      fetchUsers({
        page: 1,
        perPage: 10000,
      }),
    );
  }, [dispatch]);

  const handleTableActions = (action: TableActions) => {
    setCurrentTableSearch(action.tableSearch);

    if (
      action.tablePagination.page &&
      action.tablePagination.rowsPerPage &&
      action.tableSearch
    ) {
      if (
        action.tableSearch.selectedMonth &&
        action.tableSearch.selectedYear &&
        action.tableSearch.selectedUsers &&
        action.tableSearch.selectedRoles
      ) {
        dispatch(
          getMonthActivityWmsReports({
            page: action.tablePagination.page,
            per_page: action.tablePagination.rowsPerPage,
            selectedUsers: JSON.parse(action.tableSearch.selectedUsers),
            selectedRoles: JSON.parse(action.tableSearch.selectedRoles),
            month: action.tableSearch.selectedMonth,
            year: action.tableSearch.selectedYear,
          }),
        );
      }
    }
  };

  useEffect(() => {
    return () => {
      dispatch(clearMonthlyActivityWmsReports());
    };
  }, [dispatch]);

  const initialTableData = getMonthlyActivityTableData(usersActivity);

  const selectedRolesString = currentTableSearch?.selectedRoles;

  const filteredHeader = getFilteredTableHeader(
    selectedRolesString,
    monthlyActivityTableHeader,
    PERMANENT_KEYS,
  );

  const filteredData = filterTableDataByHeader(
    initialTableData,
    selectedRolesString,
    monthlyActivityTableHeader,
    PERMANENT_KEYS,
  );

  return (
    <TableWidget
      tableHeaderData={filteredHeader}
      tableItemsData={filteredData}
      handleTableActions={handleTableActions}
      CustomHeaderComponent={DropdownsPageHeader}
      totalItems={total}
      tableLoading={isLoading}
      withGlobalSearch={false}
      withGlobalFilter={false}
    />
  );
}

export default MonthlyActivity;
